// extracted by mini-css-extract-plugin
export default {"formContainer":"signUp_formContainer__1jo3S","journeyBox":"signUp_journeyBox__afQeQ","financial":"signUp_financial__v+ACU","physical":"signUp_physical__sqANQ"};